import { IANAZone } from 'luxon';
import isIn from 'validator/es/lib/isIn';

import {
  GROUP_BY_OPTIONS, PROPERTY_AGGREGATE_BY_OPTIONS,
  X_AXIS_DOMAIN_OPTIONS,
} from 'src/util/constants';

/**
 * Retrieve the query parameters for a property show page from the URL.
 * @param {object} props
 * @param {object} props.match
 * @param {object} props.match.location
 * @param {object} props.match.location.query
 * @param {string} props.match.location.query.tz
 * @param {string} props.match.location.query.aggregateBy
 * @param {string} props.match.location.query.groupBy
 * @param {string} props.match.location.query.xAxisDomain
 * @returns {object} the property show params.
 */
const getPropertyShowParams = (props) => {
  const { match } = props || {};
  const { location } = match || {};
  const { query } = location || {};
  const {
    tz: queryTimezone,
    aggregateBy: queryAggregateBy,
    groupBy: queryGroupBy,
    xAxisDomain: queryXAxisDomain,
  } = query || {};

  // Validate URL query parameters to handle potential typos or invalid values
  const expectedQueryAggregatedBy = queryAggregateBy
  && isIn(queryAggregateBy, PROPERTY_AGGREGATE_BY_OPTIONS);
  const expectedQueryGroupBy = queryGroupBy
  && isIn(queryGroupBy, GROUP_BY_OPTIONS);
  const expectedQueryXAxisDomain = queryXAxisDomain
  && isIn(queryXAxisDomain, X_AXIS_DOMAIN_OPTIONS);
  // A falsy tz (missing/null) is left as-is so callers fall back to the property
  // timezone; only a truthy-but-unrecognised IANA zone (e.g. a typo) is discarded,
  // since a falsy fallback check downstream (`queryTimezone || propertyTimezone`)
  // would otherwise never trigger for a bogus zone.
  const expectedQueryTimezone = !queryTimezone || IANAZone.isValidZone(queryTimezone);

  return ({
    aggregateBy: expectedQueryAggregatedBy
      ? queryAggregateBy : undefined,
    groupBy: expectedQueryGroupBy
      ? queryGroupBy : undefined,
    xAxisDomain: expectedQueryXAxisDomain
      ? queryXAxisDomain : undefined,
    timezone: expectedQueryTimezone
      ? queryTimezone : undefined,
  });
};

export default getPropertyShowParams;
